import { j as r } from '../../../_virtual/jsx-runtime.js';
import { useState as a, useEffect as i } from 'react';
const d = ({ achieved: e, isCurrent: s }) => {
  const [t, n] = a(!1);
  return (
    i(() => {
      const o = requestAnimationFrame(() => n(!0));
      return () => cancelAnimationFrame(o);
    }, []),
    /* @__PURE__ */ r.jsx('div', {
      className: 'flex-1 rounded-full bg-neutral-200 overflow-hidden',
      children: /* @__PURE__ */ r.jsx('div', {
        className: `h-full rounded-full ${e ? 'bg-primary-800' : 'bg-neutral-200'}`,
        style: {
          width: t && e ? '100%' : '0%',
          transition: s && t ? 'width 400ms ease' : void 0,
        },
      }),
    })
  );
};
export { d as ProgressBar };
